import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface CountrySelectorProps {
  value: string;
  onValueChange: (value: string) => void;
}

const countryCodes = [
  { code: "ES", dial_code: "+34", name: "Spain" },
  { code: "US", dial_code: "+1", name: "United States" },
  { code: "GB", dial_code: "+44", name: "United Kingdom" },
  { code: "FR", dial_code: "+33", name: "France" },
  { code: "DE", dial_code: "+49", name: "Germany" },
  { code: "IT", dial_code: "+39", name: "Italy" },
];

const CountrySelector: React.FC<CountrySelectorProps> = ({ value, onValueChange }) => {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger>
        <SelectValue placeholder="Select country code" />
      </SelectTrigger>
      <SelectContent>
        {countryCodes.map((country) => (
          <SelectItem key={country.code} value={country.dial_code}>
            {country.code} {country.dial_code}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CountrySelector;